import { TFileType } from '../api/scandata/types';
import { TypedRootState } from '../types';

export const selectVolumeId = (state: TypedRootState): string => state.volumeInfo.volumeId;
export const selectFileType = (state: TypedRootState): TFileType => state.volumeInfo.fileType;
